<template>
    <b-modal
        v-model="modalShow"
        size="lg"
        :title="`同じ${$locale.consultation_host}予定時刻内の予約一覧`"
        :ok-only="true"
        ok-title="閉じる"
        ok-variant="yokumiru-gray"
        @hidden="close">
        <div v-if="consultations">
            <doctor-consultations
                :doctor="doctor"
                :data-consultations="consultations"
                :searchable="searchable"
                :paginate="paginate"
                :card="card"
                :filter-start-time="filterStartTime"
                :filter-end-time="filterEndTime"
                :filter-except="filterExcept"
                :ignore-query="true"
                :can-enter="false">
            </doctor-consultations>
        </div>
    </b-modal>
</template>

<script>
    import YokumiruHelper from '../../../YokumiruHelper'

    export default {
        props: {
            doctor: {
                type: Object,
                required: true,
            },
            consultations: {
                type: Array,
                required: true,
            },
            searchable: {
                type: Boolean,
                default: true,
            },
            paginate: {
                type: Boolean,
                default: true,
            },
            card: {
                type: Boolean,
                default: true,
            },
            filterStartTime: {
                type: String,
                default: null,
            },
            filterEndTime: {
                type: String,
                default: null,
            },
            filterExcept: {
                type: Number,
                default: null,
            },
        },

        data: function() {
            return {
                helper: YokumiruHelper,
                modalShow: false,
            };
        },

        created: function() {
            bus.$on('open-modal-doctor-consultations', this.open)
            bus.$on('close-modal-doctor-consultations', this.close)
        },

        beforeDestroy: function () {
            bus.$off('open-modal-doctor-consultations')
            bus.$off('close-modal-doctor-consultations')
        },

        methods: {
            open: function () {
                this.modalShow = true
            },

            close: function () {
                this.modalShow = false
            },
        },
    }
</script>

<style scoped lang="scss">
    img {
        max-width: 240px;
    }

    .medical-courses-list .btn {
        font-size: .7rem;
        background: #98a6ad;
        border: none;
        cursor: default;

        &:focus {
            box-shadow: none;
        }
    }
</style>
